module.exports = __webpack_public_path__ + "static/media/logo@2x.487ba223.png";